const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getSessions(orgId, filters = {}) {
  const params = new URLSearchParams();
  
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.assetId) params.append('assetId', filters.assetId);
  if (filters.portId) params.append('portId', filters.portId);
  if (filters.status) params.append('status', filters.status);
  if (filters.limit) params.append('limit', filters.limit);
  if (filters.offset) params.append('offset', filters.offset);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/sessions${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view sessions');
    }
    throw new Error('Failed to fetch sessions');
  }
  
  return response.json();
}

export async function getSession(orgId, sessionId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/sessions/${sessionId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Session not found');
    }
    if (response.status === 403) {
      throw new Error('You do not have permission to view this session');
    }
    throw new Error('Failed to fetch session');
  }
  
  const data = await response.json();
  return data.session;
}
